export const AVAL_FE_VERSION: string = "0.31.3";
